module.exports = "<div class=\"navbar-header\">\n\n    <div class=\"logo\">\n        <span class=\"logo-text\">UPRT Dashboard</span>\n    </div>\n\n    <!-- <button mat-button class=\"toggle-button-navbar mat-icon-button\" fuseNavbarVertical=\"closeBar\" fxHide.gt-md>\n        <mat-icon>arrow_back</mat-icon>\n    </button> -->\n\n</div>\n\n<div class=\"navbar-content\" fusePerfectScrollbar>\n    <fuse-navigation layout=\"vertical\"></fuse-navigation>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_f0fbff5b/src/app/main/navbar/vertical/navbar-vertical.component.html
// module id = ../../../../../src/app/main/navbar/vertical/navbar-vertical.component.html
// module chunks = main